import React, { createContext, useContext, useState } from 'react';

const StockContext = createContext({
    stockSelected1: null,
    setStockSelected1: () => { console.warn("setStockSelected1 function not yet implemented."); }
});

export const useStock = () => useContext(StockContext);

export const StockProvider = ({ children }) => {
    const [stockSelected1, setStockSelected1] = useState(null);

    return (
        <StockContext.Provider value={{ stockSelected1, setStockSelected1 }}>
            {children}
        </StockContext.Provider>
    );
};
